<?xml version="1.0" encoding="UTF-8"?>
<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1000 1000">
  <defs>
    <style>
      .cls-1 {
        fill: url(#Premium_Color);
      }
    </style>
    <linearGradient id="Premium_Color" data-name="Premium Color" x1="2.83" y1="500" x2="997.17" y2="500" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#5f47c6"/>
      <stop offset=".11" stop-color="#7249b9"/>
      <stop offset=".39" stop-color="#9b4e9e"/>
      <stop offset=".64" stop-color="#ba528b"/>
      <stop offset=".85" stop-color="#cc557f"/>
      <stop offset="1" stop-color="#d3567b"/>
    </linearGradient>
  </defs>
  <path class="cls-1" d="m554.1,51.79c-9.98-20.71-31.07-33.89-54.23-33.89s-44.06,13.18-54.23,33.89l-109.53,225.37c-7.22,14.86-21.32,25.19-37.67,27.61l-244.28,36.06c-22.6,3.39-41.43,19.21-48.39,40.86s-1.32,45.57,14.88,61.57l177.75,175.88c11.57,11.45,16.85,27.82,14.14,43.87l-42,248.75c-3.77,22.6,5.65,45.57,24.29,58.94,18.64,13.37,43.31,15.06,63.65,4.33l218.04-116.41c14.72-7.86,32.38-7.86,47.1,0l218.04,116.41c20.34,10.73,45,9.23,63.65-4.33,18.64-13.56,28.06-36.34,24.29-58.94l-42.17-248.73c-2.72-16.06,2.55-32.44,14.13-43.9l177.74-175.86c16.19-16.01,22.03-39.92,14.88-61.57s-25.8-37.47-48.39-40.86l-244.46-36.07c-16.35-2.41-30.45-12.75-37.67-27.61l-109.53-225.37Z"/>
</svg>